import defaultTheme from './defaultTheme';
const nissanTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#808080', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#808080', background: '#808080' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#808080' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#808080', border: '#808080', background: '#808080' }), field: {
        focus: '#808080',
        label: '#808080',
        icon: '#808080',
    } });
export default nissanTheme;
